import { Checkbox, CheckboxProps } from "@heroui/react";
import { MantineFormValues } from "./shared.types";
import React from "react";

type LimeCheckboxProps = MantineFormValues & CheckboxProps;

export const LimeCheckbox = React.forwardRef(
  (props: LimeCheckboxProps, ref: React.Ref<HTMLInputElement>) => (
    <Checkbox
      ref={ref}
      {...props}
      isSelected={props.value ?? props.checked ?? props.isSelected}
    >
      {props.children}
    </Checkbox>
  ),
);
LimeCheckbox.displayName = "LimeCheckbox";
